<div class="title-area">
  <h2 mat-subheader class="title">アカウント管理</h2>
  <div class="title-sub-row">
    <div class="title-desc">
      アカウント作成用URL ：
      <a (click)="openSignupUrl()">
        {{ Constant.unionestSignupUrl }}{{ companyCode }}
      </a>
    </div>
    <div class="permission-trigger" (click)="togglePermission()">
      <mat-icon class="icon" >info</mat-icon>
      権限について
    </div>
  </div>
</div>

@if (isPermissionOpen) {
  <div class="permission-overlay" (click)="togglePermission()">
    <div class="permission-panel" (click)="$event.stopPropagation()">

      <table class="permission-table">
          <thead>
            <tr>
              <th>権限名</th>
              <th>アカウント<br>権限変更 / パスワードリセット / 削除</th>
              <th>組織情報 / マスタ設定<br>登録・編集など</th>
            <!--  <th>完了したイベント<br>削除</th> -->
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>管理</td>
              <td>○</td>
              <td>○</td>
              <!-- <td>○</td> -->
            </tr>
            <tr>
              <td>準管理</td>
              <td>「運用」以下のユーザーに対して可能</td>
              <td>○</td>
              <!-- <td>×</td> -->
            </tr>
            <tr>
              <td>運用</td>
              <td>「メンバー」以下のユーザーに対して可能</td>
              <td>×</td>
              <!-- <td>×</td> -->
            </tr>
            <tr>
              <td>メンバー</td>
              <td>×</td>
              <td>×</td>
              <!-- <td>×</td> -->
            </tr>
            <tr>
              <td>なし（未承認）</td>
              <td>×</td>
              <td>×</td>
              <!-- <td>×</td> -->
            </tr>
          </tbody>
      </table>

    </div>
  </div>
}

@if (showSpinner) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <table class="account-content">
    <tr>
      <th class="user_id">ID</th>
      <th class="name">名前</th>
      <th class="affiliation">担当</th>
      <th class="comment">申請コメント</th>
      <th class="user_authority">権限</th>
      <th class="encrypted_password">パスワード</th>
      <th class="last_access_date">最終アクセス</th>
      <th class="btn-edit">Menu</th>
    </tr>
    @for (account of accounts; track account.id; let idx = $index) {
      <tr>
        <td class="user_id">
            {{ account.user_id }}
        </td>
        <td class="name">
          <div class="officialposition_name">
            {{ account.officialposition_name }}
          </div>
          {{ account.last_name }} {{ account.firstName }}
        </td>
        <td class="affiliation">
          <div class="cell-scroll">
            <div class="cell-inner">
              <div class="selected-orgs" *ngIf="account.organizations?.length || account.concurrent_organizations?.length">
                <div *ngFor="let org of account.organizations" class="org-item">
                  ・{{ org.level === 0 
                      ? org.path 
                      : getMasterTypeName(org.master_type) + ' ' + org.path }}
                </div>
                <div *ngFor="let con_org of account.concurrent_organizations" class="org-item">
                  ・専門部 {{ con_org.path }}
                </div>
              </div>
            </div>
          </div>
        </td>
        <td class="comment">
          <div class="cell-scroll">
            <div class="cell-inner">
              {{ account.comment }}
            </div>
          </div>
        </td>
        <td class="user_authority" [ngSwitch]="account.user_authority">
          <span *ngSwitchCase="0">管理</span>
          <span *ngSwitchCase="1">準管理</span>
          <span *ngSwitchCase="2">運用</span>
          <span *ngSwitchCase="3">メンバー</span>
          <span *ngSwitchCase="4">
            なし<span class="unauthorized">（未承認）</span>
          </span>
          <span *ngSwitchDefault>
            なし<span class="unauthorized">（未承認）</span>
          </span>
        </td>
        <td class="encrypted_password">
          <div
            [class.masked]="!account.encrypted_password"
          >
            {{ account.encrypted_password || '***' }}
          </div>
          @if (account.password_updated_at) {
            <div
              class="password-expire"
              [class.expired]="isPasswordExpired(account.password_updated_at)"
            >
              {{ getPasswordExpireText(account.password_updated_at) }}
            </div>
          }
        </td>
        <td class="last_access_date">{{ account.last_access_date ? formatDate(account.last_access_date) : '' }}</td>
        <td class="btn-edit">
          @if (!(idx === 0 && account.user_authority === 0)) {
            <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-btn" (keydown.enter)="$event.preventDefault()">
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #menu="matMenu" overlapTrigger="false">
              <button mat-menu-item (click)="onEdit(idx)" (keydown.enter)="$event.preventDefault()" >権限変更</button>
              <button mat-menu-item (click)="onPasswordReset(idx)" (keydown.enter)="$event.preventDefault()">パスワードリセット</button>
              <button mat-menu-item (click)="onDel(idx)" (keydown.enter)="$event.preventDefault()">削除</button>
            </mat-menu>
          }
        </td>
      </tr>
    }
  </table>
}

@if (!showSpinner && accounts && accounts.length == 0) {
  <div
    class="no-accounts"
    >
  </div>
}
